import {type Dispatch, type SetStateAction, useState} from 'react'

/**
 * Tracks whether the timeline highlight borders should be visible. Starts as
 * `true` when a highlight is active, and resets back to `true` whenever the
 * highlight id changes (so following a new highlight link restores the border).
 * Local writes via the setter persist until the next id change — used by the
 * click-to-clear handler in `TimelinePanel`.
 */
export function useHighlightVisibility(highlightId: string | undefined): [boolean, Dispatch<SetStateAction<boolean>>] {
  const [visible, setVisible] = useState<boolean>(highlightId !== undefined)
  const [prevHighlightId, setPrevHighlightId] = useState(highlightId)
  if (highlightId !== prevHighlightId) {
    setPrevHighlightId(highlightId)
    if (highlightId) {
      setVisible(true)
      return [true, setVisible]
    }
  }
  return [visible, setVisible]
}
